<template #content>
    <Dialog
        :visible="visible"
        @update:visible="updateVisible"
        header="Confirmação"
        @show="onShow"
        @hide="onHide"
        class="w-11 lg:w-4"
        modal >
        <form @submit.prevent="onSubmit(form)">
            <div class="w-full">
                <div class="field mt-4">
                    <InputGroup>
                        <FloatLabel>
                            <InputText id="cliente_id" v-model="form.cliente" class="w-full" readonly />
                            <label for="cliente_id">Cliente<span class="text-red-500">*</span></label>
                        </FloatLabel>
                        <Button icon="pi pi-search" severity="info" @click="visibleClienteListaSelect = true"></Button>
                        <Button icon="pi pi-times" severity="danger" @click="clearCliente"></Button>
                    </InputGroup>
                    <div class="text-xs text-red-500">{{ errors['cliente_id'] }}</div>
                </div>

                <div class="field mt-4">
                    <FloatLabel>
                        <InputText v-model="form.id_primario" class="w-full" />
                        <label>ID Primario<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['id_primario'] }}</div>
                </div>

                <div class="field mt-4">
                    <FloatLabel>
                        <InputText v-model="form.site" class="w-full" />
                        <label>Site/Localidade<span class="text-red-500">*</span></label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['site'] }}</div>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button
                        type="submit"
                        label="Salvar"
                        severity="success"
                        icon="pi pi-save"
                        size="small"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
                    <Button
                        label="Fechar"
                        severity="warn"
                        icon="pi pi-times"
                        size="small"
                        @click="updateVisible(false)"
                        class="flex align-items-center justify-content-center"
                        :loading="isLoading" />
            </div>
        </form>

        <ClienteListaSelect :visible="visibleClienteListaSelect" :permissoes="permissoes" @close="visibleClienteListaSelect = false" @select="selectCliente" />
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import Button from 'primevue/button';
import Select from 'primevue/select';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import ClienteListaSelect from '@/page/cliente/ListaSelect.vue';

export default {
    components: { 
        Dialog,
        InputGroup,
        InputGroupAddon,
        FloatLabel,
        InputText,
        Checkbox,
        Select,
        Button,

        ClienteListaSelect,
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: {}
        },
        errors: {},
        permissoes: {},
    },
    emits: ['submit','close'],
    data() {
        return {
            form: {},
            isLoading: false,
            visibleClienteListaSelect: false,

            layoutOpt: [],
            isLoadingLayoutOpt: false,

            STATUS: constantes.UPLOAD,
        }
    },
    methods: {
        selectCliente(cliente) {
            this.form.cliente       = null;
            this.form.cliente_id    = null;

            if(cliente) {
                this.form.cliente       = cliente.nome;
                this.form.cliente_id    = cliente.id;
            }
        },
        clearCliente() {
            this.form.cliente       = null;
            this.form.cliente_id    = null;
        },
        onShow() {
            
        },
        onHide() {
            this.form = {};
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        onSubmit(form) {
            this.$emit('submit', form);
        },
    },
}
</script>
